import React from 'react';
import { Card, CardBody } from '@one-thd/sui-atomic-components';
import { EmailList } from '@thd-olt-component-react/list-forms';
import ShareableListCardPlaceholder from './ShareableListCardPlaceholder';
import ListHeader from './sub-components/ListHeader';
import ListImages from './sub-components/ListImages';
import { ShareableListCardPropTypes, ShareableListCardDefaultProps } from './utils/propTypes';

const ShareableListCard = ({ list, numberOfThumbnails, disableSharedIcon, sharedIconSize }) => {
  if (!list) {
    return <ShareableListCardPlaceholder numberOfThumbnails={numberOfThumbnails} />;
  }

  const {
    name, url, itemCount, images
  } = list;

  return (
    <Card
      data-component="ShareableListCard"
      data-testid="lists-details"
      className="sui-w-full sui-h-full [&>div]:sui-h-full sui-max-w-sm [&>div]:sui-justify-between"
    >
      <div className="sui-flex sui-justify-between sui-items-start sui-gap-6">
        <ListHeader name={name} url={url} itemCount={itemCount} />
        {disableSharedIcon || itemCount === 0 ? null : (
          <EmailList listId={list.id} iconSize={sharedIconSize} shareIcon />
        )}
      </div>
      <CardBody disableGrow>
        <ListImages
          images={images}
          itemCount={itemCount}
          numberOfThumbnails={numberOfThumbnails}
        />
      </CardBody>
    </Card>
  );
};

ShareableListCard.propTypes = ShareableListCardPropTypes;
ShareableListCard.defaultProps = ShareableListCardDefaultProps;

export default ShareableListCard;